/**
 * Tonos de estado. Son los del sistema de diseño y no hay más.
 *
 * Regla dura del documento: el color de estado aparece como punto, texto o
 * borde izquierdo — **nunca como fondo completo de una fila.** Una tabla con
 * filas rojas y verdes es ilegible a los 20 registros.
 */
export type Tono = 'neutral' | 'marca' | 'verde' | 'ambar' | 'rojo' | 'azul'

/** Color sólido del punto. Es lo único que se pinta con el color de estado. */
export const COLOR_PUNTO: Record<Tono, string> = {
  neutral: 'bg-gris-400',
  marca: 'bg-marca',
  verde: 'bg-verde',
  ambar: 'bg-ambar',
  rojo: 'bg-rojo',
  azul: 'bg-azul',
}

/** Color del texto cuando el texto mismo debe llevar el tono (errores). */
export const COLOR_TEXTO: Record<Tono, string> = {
  neutral: 'text-gris-600',
  marca: 'text-marca',
  verde: 'text-verde',
  ambar: 'text-ambar',
  rojo: 'text-rojo',
  azul: 'text-azul',
}

/** Fondo tenue. Solo para banners y avisos, nunca para filas de tabla. */
export const FONDO_TENUE: Record<Tono, string> = {
  neutral: 'bg-gris-100',
  marca: 'bg-marca-tenue',
  verde: 'bg-verde-tenue',
  ambar: 'bg-ambar-tenue',
  rojo: 'bg-rojo-tenue',
  azul: 'bg-azul-tenue',
}

/** Borde izquierdo de 3px: la otra forma admitida de mostrar el tono. */
export const BORDE_IZQUIERDO: Record<Tono, string> = {
  neutral: 'border-l-gris-400',
  marca: 'border-l-marca',
  verde: 'border-l-verde',
  ambar: 'border-l-ambar',
  rojo: 'border-l-rojo',
  azul: 'border-l-azul',
}
